import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import Vue from 'vue'

extend('no_only_whitespace', {
  validate(value) {
    return value.trim().length > 0;
  }
})

extend('no_leading_whitespace', {
  validate(value) {
    return !/^\s+/.test(value) && value.length >= 2
  }
})

extend('min_length', {
  validate(value, { length }) {
    if (/^\s+/.test(value)) {
      return true
    }
    return value.trim().length >= length
  },
  params: ['length'],
});

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
